import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useModelPopup } from '../../../../../../common/hooks';

import { projectGet } from '../../../project.action';
import { projectMultipleUsersAdd } from '../../../users/user.action';

import { ModalFooter, ModalBody } from '../../../../../../application/modal';
import {
  Button,
  BtnType,
  Label,
  MultiSelect,
  DropSelect,
} from '../../../../../primitives';
import styles from './addMember.module.scss';
import { useSnackbar } from 'notistack';

const optionRoles = [
  {
    text: 'Project Member',
    value: 'member',
  },
  {
    text: 'Project Manager',
    value: 'manager',
  },
  {
    text: 'Project Owner',
    value: 'owner',
  },
];

const AddCompanyComponent = ({ projectId, isOwner, adminRights }) => {
  const popup = useModelPopup();
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const [selected, setSelected] = useState([]);
  const [role, setRole] = useState('member');

  const {
    authReducer: { session },
    councilReducer: { usersList },
    projectsReducer: {
      projectReducer: { selectedProject },
    },
  } = useSelector((state) => state);

  const handleCancelClick = (e) => {
    popup.hide();
  };
  const handleItemSelect = (values) => {
    setSelected(values);
  };
  const handleSaveClick = async (e) => {
    if (selected.length > 0) {
      const payload = {
        projectId: selectedProject.id,
        role,
        enqueueSnackbar,
        project_members: selected.map(member => ({
          project_id: selectedProject.id,
          user_id: member.id
        }))
      };

      await dispatch(
        projectMultipleUsersAdd(payload)
      );
      await dispatch(projectGet({ id: selectedProject.id, enqueueSnackbar }));
      popup.hide();
    }
  };

  const handleRoleChange = ({ val }) => {
    setRole(val);
  };


  const userListFormatted = usersList
    .map((user) => ({
      id: user.id,
      name: `${user.first_name} ${user.last_name}`,
      ...user,
    }))
    .filter(function (o1) {
      return !selectedProject.project_members.find(function (o2) {
        return o1.id === o2.user.id;
      });
    });

  return (
    <div className={styles.addCompanyWrp}>
      <ModalBody>
        <Label>Users</Label>
        {usersList && usersList[0] && (
          <MultiSelect
            onChange={handleItemSelect}
            placeholder="Choose project member"
            labelField="name"
            valueField="id"
            searchBy="name"
            options={userListFormatted}
          />
        )}

        {adminRights() && (
          <DropSelect
            onChange={handleRoleChange}
            placeholder="Choose a role"
            labelField="text"
            valueField="value"
            searchBy="text"
            options={optionRoles}
          />
        )}
      </ModalBody>
      <ModalFooter>
        <Button btn={BtnType.FRAME_LESS} onClick={handleCancelClick}>
          Cancel
        </Button>
        <Button
          type="submit"
          btn={BtnType.REGULAR}
          onClick={() => handleSaveClick()}
        >
          Save
        </Button>
      </ModalFooter>
    </div>
  );
};

export default AddCompanyComponent;
